import { ContentItem, ContentItemFieldCollection } from './content-item';

export function getSponsoredContentConfig(
    adConfig: ContentItemFieldCollection | SponsoredContentConfig
): SponsoredContentConfig {
    if (
        adConfig &&
        Object.keys(adConfig)?.filter(key => ['advertiserName', 'adPayerName', 'adDisplayParameters'].includes(key))
            .length == 3
    ) {
        const { advertiserName, adPayerName, adDisplayParameters } = adConfig;
        if (!!advertiserName && !!adPayerName && (adDisplayParameters as string[]).length) {
            return { advertiserName, adPayerName, adDisplayParameters } as SponsoredContentConfig;
        }
    }

    return;
}

export function getSponsoredContentConfigForProductMap(contentItem: ContentItem): Map<string, SponsoredContentConfig> {
    const sponsoredProducts = contentItem?.fields['sponsoredProducts'] as CarouselProductSponsoredContentConfig[];
    if (!Array.isArray(sponsoredProducts) || !sponsoredProducts.length) {
        return new Map();
    }

    return sponsoredProducts.reduce(
        (
            productSponsoredContentConfigMap: Map<string, SponsoredContentConfig>,
            sponsoredProduct: CarouselProductSponsoredContentConfig
        ) => {
            productSponsoredContentConfigMap.set(
                sponsoredProduct.code,
                getSponsoredContentConfig(sponsoredProduct.sponsoredContentConfig)
            );

            return productSponsoredContentConfigMap;
        },
        new Map()
    );
}

export interface SponsoredContentConfig {
    advertiserName: string;
    adPayerName: string;
    adDisplayParameters: string[];
}

export interface CarouselProductSponsoredContentConfig {
    code: string;
    sponsoredContentConfig: SponsoredContentConfig;
}
